import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Media from './media';
import Advertorial from '../../advertorial/advertorial';
import Eyebrow from '../../eyebrow/eyebrow';
import FCLink from '../../fc_link/fc_link';

export default class Header extends Component {
  shouldComponentUpdate() {
    return false;
  }

  render() {
    const {
      advertorial,
      tags,
      post,
      combinedAdModel,
      currentSite,
      isFirstPost,
      videoAdData
    } = this.props;
    const { title } = post;

    return (
      <header className="post__header">
        {advertorial
          ? <Advertorial tags={tags} adModel={combinedAdModel} />
          : ''}

        <Eyebrow post={post} tags={tags} />

        <FCLink
          currentSite={currentSite}
          externalLink={!isFirstPost}
          to={post.link}
          title={post.title}
        >
          {isFirstPost
            ? <h1 className="post__title">{title}</h1>
            : <h2 className="post__title">{title}</h2>}
        </FCLink>

        <h2
          className="post__deck"
          dangerouslySetInnerHTML={{ __html: post.excerpt }}
        />

        <Media post={post} videoAdData={videoAdData} />
      </header>
    );
  }
}

Header.propTypes = {
  currentSite: PropTypes.string.isRequired,
  tags: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  advertorial: PropTypes.bool.isRequired,
  post: PropTypes.shape({}).isRequired,
  combinedAdModel: PropTypes.shape({}).isRequired,
  isFirstPost: PropTypes.bool.isRequired,
  videoAdData: PropTypes.shape({}).isRequired
};



// WEBPACK FOOTER //
// ./src/views/components/post/content/header.js